export default "__VITE_ASSET__LTLOYb_U__"